// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-state-item.styled.classic.js, новая — rack-state-item.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-state-item.styled.classic';
import * as cp from './rack-state-item.styled.cp';

export const Item = isCp ? cp.Item : classic.Item;
export const Title = isCp ? cp.Title : classic.Title;
export const Value = isCp ? cp.Value : classic.Value;
